import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BookOpen icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BookOpen } from '@sravni/design-system-icons'
 *
 * <BookOpen />
 * ```
 */
var BookOpen = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BookOpen", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 4.167h.834c.92 0 1.666.745 1.666 1.666v10c0 .921-.745 1.667-1.666 1.667H3.333c-.92 0-1.666-.746-1.666-1.667v-10c0-.92.746-1.666 1.666-1.666h.834", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 5a2.5 2.5 0 0 0-2.5-2.5H5a.834.834 0 0 0-.833.833v10.834c0 .46.373.833.833.833h2.5a2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1 2.5-2.5H15c.46 0 .833-.373.833-.833V3.333A.834.834 0 0 0 15 2.5h-2.5A2.5 2.5 0 0 0 10 5ZM10 5v12.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BookOpen };
//# sourceMappingURL=BookOpen.js.map
